import moment from "moment";
import type { DateValueType } from "react-tailwindcss-datepicker";
import { getChecklistDefaultPeriodDate } from "src/modules/checklistTasks/utils";

export function addDate(amount: moment.DurationInputArg1, unit: moment.unitOfTime.DurationConstructor, inp?: Date) {
  return moment(inp).add(amount, unit).toDate();
}

export function getMinutes(milliseconds: number) {
  return Math.floor(milliseconds / 60000);
}

export function getDiffDays(from: Date = new Date(), to: Date) {
  let difference = from.getTime() - to.getTime(); // This will give difference in milliseconds
  return Math.round(difference / 60000 / 60 / 24);
}

export function getDefaultPeriodDate(): DateValueType {
  return getChecklistDefaultPeriodDate();
}
